import { CacheUtility } from '@utility/cache';
import { BaseService } from './base';
import { APIPath } from '../constants/api';
import { CommonUtility } from '../common';

class Prediction {
  daysLeft = params => {
    const reqParams = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.predictionDaysLeft}/?${reqParams}`);
  };

  getInventoryTimeline = async (params, forceRefresh = false) => {
    const reqParams = CommonUtility.objectToParams(params);
    const url = `${APIPath.scmInventoryTimeline}/?${reqParams}`;
    const cache = CacheUtility.get(url);

    if (cache && !forceRefresh) {
      return cache;
    }

    const result = await BaseService.get(url);

    CacheUtility.save(url, result);
    return result;
  };

  refreshInventoryTimeline = async params =>
    BaseService.put(`${APIPath.shipmentTimelineRefresh}`, params);

  getPurchaseOrderTimeline = async (upc, forceRefresh = false) => {
    const url = `${APIPath.scmPurchaseOrderTimeline}/?upc=${upc}`;
    const cache = CacheUtility.get(url);
    if (cache && !forceRefresh) {
      return cache;
    }
    const result = await BaseService.get(
      `${APIPath.scmPurchaseOrderTimeline}/?upc=${upc}`,
    );
    CacheUtility.save(url, result);
    return result;
  };

  getGlobalItem = (upc, supplier_id) =>
    BaseService.get(
      `${APIPath.purchaseOrderGlobalTimeline}/${upc}/${supplier_id}`,
    );

  updateVelocity = data => BaseService.put(APIPath.updateVelocity, data);

  refreshPurchaseOrderTimeline = data =>
    BaseService.put(APIPath.providerTimelineRefresh, data);

  updateMOQ = data => BaseService.put(APIPath.providerTimelineMOQ, data);

  getRegionalItem = id =>
    BaseService.get(`${APIPath.providerRegionalItem}/${id}`);

  updateItemVariables = data =>
    BaseService.put(APIPath.itemTimelineSettings, data);
}

const PredictionService = new Prediction();
Object.freeze(PredictionService);
export default PredictionService;
